/**
 * @store/ui — Ephemeral cross-route UI state.
 *
 * For modal/sheet flags that span more than one component but don't
 * deserve their own Context. NOT for page-local state (use useState),
 * NOT for filter/search state (use the URL), NOT for server data
 * (use the API layer).
 *
 * Examples that belong here:
 *   • Mobile filter sheet open/close (currently page-local; can migrate
 *     when filter chips elsewhere need to reopen the sheet).
 *   • "Add to Shortlist" picker target id (lives in a global popover).
 *   • Presentation mode toggle (currently in AuthContext — could move
 *     here later since it's pure UI).
 */

import { create } from "zustand";

export const useUiStore = create((set) => ({
  /** Id of the property the global "Add to Shortlist" picker is targeting,
   *  or null if the picker is closed. */
  shortlistPickerFor: null,
  openShortlistPicker: (propertyId) => set({ shortlistPickerFor: propertyId }),
  closeShortlistPicker: () => set({ shortlistPickerFor: null }),

  /** Mobile filter sheet open flag. */
  mobileFilterOpen: false,
  setMobileFilterOpen: (open) => set({ mobileFilterOpen: !!open }),
}));
